import { createRoot } from "react-dom/client";
import { StoreProvider } from "../app/storeProvider";
import React from "react";
import HouseCompetition from "../app/(general-header)/prizes/house/page";

const root = createRoot(document.getElementById("house-container") as HTMLElement);

root.render(
  <React.StrictMode>
    <StoreProvider>
      <HouseCompetition />
    </StoreProvider>
  </React.StrictMode>
);
